import { cx } from "@ui/utils/cx";
import loadingWhite from "../assets/loading-white.webp";

export interface PendingOverlayProps {
  /** Inverts the white spinner to dark for light fills (yellow / white) where white would vanish. */
  invert?: boolean;
  /** Renders nothing unless pending, so call sites stay unconditional. */
  isPending?: boolean;
}

/**
 * Absolutely-centred pending spinner shared by the styled button variants. The host
 * button must be `relative`; pair with {@link ButtonContent}, which turns the label
 * invisible while pending so the button keeps its size.
 */
export function PendingOverlay({ invert, isPending }: PendingOverlayProps) {
  if (!isPending) return null;

  return (
    <span aria-hidden className="absolute inset-0 flex items-center justify-center">
      <img alt="" className={cx("h-[1lh] w-auto", invert && "invert")} src={loadingWhite} />
    </span>
  );
}
